import styled from '@emotion/styled';
import { Paper, List, ListItemButton, ListItemText, Button, Box, IconButton } from '@mui/material';

export const SidebarWrapper = styled(Paper)(() => ({
    padding: '20px 15px',
    height: '100%', 
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--grey-100)', 
    borderRight: `1px solid var(--grey-300)`, 
    boxShadow: 'none', 
}));

export const NewWorkflowButton = styled(Button)(() => ({
    marginBottom: '20px',
    backgroundColor: 'var(--secondary-main)', 
    color: 'white',
    '&:hover': {
        backgroundColor: 'var(--secondary-dark)',
    },
}));

export const WorkflowList = styled(List)({
    flexGrow: 1,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
    },
});

export const WorkflowListItem = styled(ListItemButton)(() => ({
    borderRadius: '4px',
    marginBottom: '5px',
    paddingRight: '40px',
    position: 'relative',
    backgroundColor: 'var(--plain-white)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    '&.Mui-selected': {
        backgroundColor: 'var(--secondary-sub)',
        '&:hover': {
            backgroundColor: 'var(--secondary-subs)', 
        },
        '.MuiListItemText-primary': {
            fontWeight: 600, 
            color: 'var(--background-default)',
        },
        '.MuiListItemText-secondary': {
            color: 'var(--background-default)', 
        },
    },
    '&:hover': {
        backgroundColor: 'var(--secondary-light)',
    },
}));

export const WorkflowActionsButton = styled(IconButton)({
    position: 'absolute',
    right: '5px',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '4px', 
    color: 'var(--grey-500)', 
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)', 
        color: 'var(--grey-700)',
    },
});

export const StyledListItemText = styled(ListItemText)({
    '.MuiListItemText-primary': {
        fontSize: '0.95rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    '.MuiListItemText-secondary': {
        fontSize: '0.8rem',
        color: 'var(--grey-600)',
    },
});

export const EmptyState = styled(Box)({
    textAlign: 'center',
    color: 'var(--grey-500)',
    padding: '20px',
    fontSize: '0.9rem',
});
